/** @jsx jsx */
import { ThemeProvider, jsx } from '@emotion/react';

import * as React from 'react';

import { degreeDescriptionPageTheme } from '../degreeDescriptionPageTheme';

const DegreeDescriptionPageThemeProvider: React.FC = ({ children }) => {
  return <ThemeProvider theme={degreeDescriptionPageTheme}>{children}</ThemeProvider>;
};

export default DegreeDescriptionPageThemeProvider;
